<template>
    <div>
        <div style="text-align:center;width: 50%;margin: 0 auto;">
            <h1>Waters Contracting</h1>
            
        </div>
    </div>
</template>

<script>
export default {
  name: 'Pricing',
}
</script>